import { render, staticRenderFns } from "./GenerationContentItems.vue?vue&type=template&id=3f63e258&"
import script from "./GenerationContentItems.vue?vue&type=script&lang=js&"
export * from "./GenerationContentItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports